let fadeOptions = {
	"duration": 250,
}


export function bovenstelijn_viewportEnter(event) {
    $w('#Hideyheader').hide("fade", fadeOptions);
}

export function bovenstelijn_viewportLeave(event) {
   $w('#Hideyheader').show("fade", fadeOptions);
}